import navbar from "./navbar";
import burger from "./burger";

export default {
    navbar,
    burger,
};
